import PropTypes from "prop-types";

const HeartOutlineIcon = ({ width = 18, height = 18, fill = "#868C98" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.00091 2.27598C11.115 0.377884 14.382 0.440884 16.4187 2.48118C18.4545 4.52238 18.5247 7.77318 16.6311 9.89358L8.9991 17.5364L1.36891 9.89358C-0.524695 7.77318 -0.453594 4.51698 1.58131 2.48118C3.61981 0.443584 6.88051 0.375184 9.00091 2.27598ZM15.1443 3.75288C13.7943 2.40108 11.6163 2.34618 10.2033 3.61518L9.0018 4.69338L7.79941 3.61608C6.38191 2.34528 4.20841 2.40108 2.85481 3.75468C1.51381 5.09568 1.44631 7.24218 2.68201 8.66058L9 14.9885L15.318 8.66148C16.5546 7.24218 16.4871 5.09838 15.1443 3.75288Z"
      fill={fill}
    />
  </svg>
);

HeartOutlineIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string
};

export default HeartOutlineIcon;
